export const styles = {
  supportItem: {
    display: "flex",
    alignItems: "center",
    borderRadius: 2,
    border: "1px solid #E5E5E5",
    p: "24px 20px",
    width: "100%",
  },
};
